import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const GLOBAL = require('../../Globals');

class ElectiveReport extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			cls : '',
			section : '',
			subj : '',
			_message : '',
			alertClass :'',
			posts : [],
			data : [],
			rollnum : this.refs.rollnum,
			std_id : '',
			 _redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}
	
	 printDocument() {
		const input = document.getElementById('printableTable');
		html2canvas(input)
		  .then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF();
			pdf.addImage(imgData, 'JPEG', 0, 0);
			pdf.save("download.pdf");
		  })
		;
		/* window.frames["print_frame"].document.body.innerHTML = document.getElementById("printableTable").innerHTML;
         window.frames["print_frame"].window.focus();
         window.frames["print_frame"].window.print(); */
		
	 }
	
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.refs.rollnum && this.refs.std_id){
			
			PostData('student/rnoupdate',this.refs).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Category Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("rollform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('student/deletecategory',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Student Category Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Student Category',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	componentDidMount() {
		 
		// this.getdata();
		this.getclass();
	}
	
	/* getdata(){
		
		GetData('student/getstdbysecandcls/'+this.state.cls+'/'+this.state.section).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	} */
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

	}
	
	var items = this.state.posts;
	var sec = this.state.secs;
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	  /** get Section By Class **/
	$("#secs").change(function(){
		var fr = $(this).val();
		var cr = $("#clas").val();
		$.get(GLOBAL.BASE_URL+'subject/getsubbyclsandsec/'+cr+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});
			
		},'json');
	
	});
	
	// $("#roll").hide(1000);
	
	$("#sub").change(function(){
		var sr = $("#secs").val();
		var fr = $("#clas").val();
		/* GetData('student/getstdbysecandcls/'+fr+'/'+sr).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});  */
		$.get(GLOBAL.BASE_URL+'student/getstdbysecandcls/'+fr+'/'+sr,function(o){
			
			$("#elereport").html('');
			$('#elereport')
			$.each(o,function(key,value){			
				$('#elereport')
					.append('<tr><td>'+value.id+'</td><td>'+value.admissionno+'</td><td>'+value.stdname+'</td></tr>');
			});
		},'json');
		
	});
	
	var tableStyle = {
       "border": "1px solid black"
    };
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
					<CardHeader>
						<strong>Elective Subject Report</strong>
					</CardHeader>
					<CardBody>
						<Row>
						 <Col md="12">
							<Row>
								<Col md="3">
								  <FormGroup>
									<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
									<select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
										<option value="">Select Class</option>
										{
											items.map(function (item) {
												return <option value={item.id }>{item.class}</option>;
											})
										}
									</select>
								  </FormGroup>
								</Col>
								<Col md="3">
								  <FormGroup>
									<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
									<select name="section" onChange={this.onChange} className="form-control" id="secs" required>
											
									</select>
								  </FormGroup>
								</Col>
								<Col md="3">
								  <FormGroup>
									<Label htmlFor="name">Elective Subject <span className="text-danger">*</span></Label>
									<select name="subj" onChange={this.onChange} className="form-control" id="sub" required>
											
									</select>
								  </FormGroup>
								</Col>
								<Col md="3">
								  <FormGroup id="btn-top">
									<Button size="sm" color="primary" onClick={this.printDocument}><i className="fa fa-print"></i> Download Pdf</Button>
								  </FormGroup>
								</Col>
							</Row>
						 </Col>
						</Row>
					</CardBody>
				</Card>
			  </Col>
			  <Col md="12">
			   <Card id="printableTable">
				<CardHeader>
					<strong>Elective Subject Report</strong>
				</CardHeader>
				<CardBody>
				<Table responsive bordered >
					<thead>
						<tr>
							<th>S.No</th>
							<th>Admission No</th>
							<th>Student Name</th>
						</tr>
					</thead>
					<tbody id="elereport">
						
					</tbody>
				</Table>
				</CardBody>
				<iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default ElectiveReport;


// WEBPACK FOOTER //
// ./src/report/ElectiveReport/ElectiveReport.js